// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"k4-z","displaySixCardTiles":"l4-z"};